import { NgModule } from '@angular/core';
import { LensWidgetComponent } from 'components/work-item-lane-list/work-item-lane/work-item-widget/lens-widget/lens-widget.component';
import { LensModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/components/lens/lens.module';

@NgModule({
  imports: [
    LensModule
  ],
  declarations: [
    LensWidgetComponent
  ],
  exports: [
    LensWidgetComponent
  ]
})
export class LensWidgetModule {}
